export type UseOnboardingReturn = {
    isOnboardingInProgress: ComputedRef<boolean>;
};

export const useOnboarding = (): UseOnboardingReturn => {
    const { data: session } = useAuthUtils();

    const isOnboardingInProgress = computed(() => session.value?.user?.onboardingSessionFinishedAt === null);

    return {
        isOnboardingInProgress,
    };
};
